import React from "react";
import T from "prop-types";
import { Map } from "immutable";

import { ACCOUNTING } from "MODULES/users/constants";
import { Form as AppForm } from "MODULES/shared/components/Forms";
import CustomerSection from "MODULES/SalesOrders/components/shared/FormSections/CustomerSection";
import withCurrentUser, {
  WithCurrentUser
} from "MODULES/session/decorators/withCurrentUser";
import { CREATED_BY_ID } from "APP_ROOT/constants";
import { AFTER_HOURS } from "MODULES/SalesOrders/constants";
import { COMPANY } from "MODULES/companies/constants";
import { hasRole } from "MODULES/users/helpers";

function Form({ salesOrder, currentUser, ...props }) {
  const canEditCompany =
    salesOrder.get(CREATED_BY_ID) === currentUser.id ||
    hasRole(currentUser, ACCOUNTING);

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <CustomerSection
          formName={"editSalesOrderCustomer"}
          company={salesOrder.toJS().company}
          creditTerms={salesOrder.getIn([COMPANY, "customer_credit_terms"])}
          afterHours={salesOrder.get(AFTER_HOURS)}
          canEditCompany={canEditCompany}
          setFieldValue={field => val => props.change(field, val)}
          setPrimaryContact={false}
        />
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  salesOrder: T.instanceOf(Map).isRequired,
  ...WithCurrentUser
};

export default withCurrentUser(Form);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Panel/Details/Form.jsx